import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";

import EventStartDate from "../EventStartDate/EventStartDate";
import EventStartTime from "../EventStartTime/EventStartTime";
import EventLocation from "../EventLocation/EventLocation";
import IEvent from "../../dataProvider/interfaces/IEvent";
import { RiGroupLine } from "react-icons/ri";
import EventStatus from "../EventStatus/EventStatus";
import FdTypography from "../UIComponents/Typography/FdTypography";
import {eventList as classes} from "./styles";

export interface Props {
  events: IEvent[];
  selectEvent: Function;
}



const EventsList = ({ events, selectEvent }: Props) => {

  const handleSelectEvent = (event: IEvent) => {
    selectEvent(event);
  };

  const showEventsList = (events: IEvent[]) => {
    return events.map((event) => {
      return (
        <Grid key={event.id || event.thirdPartyId} item xs={6}>
          <Card
            sx={classes.cardItem}
            onClick={(e: any) => {
              handleSelectEvent(event);
            }}
          >
            <CardContent sx={classes.cardContent}>
              {event.logoUrl && (
                <Box width="75px">
                  <Avatar
                    alt="event-avatar"
                    src={event.logoUrl}
                    sx={classes.eventLogo}
                  />
                </Box>
              )}
              <Box width={event.logoUrl ? "calc(100% - 75px)" : "100%"}>
                <FdTypography label={event.name} variant="h2" component="h2" align="left" />
                <Box
                  mb={3}
                  sx={classes.cardContentItem}
                  marginTop="10px"
                >
                  {event.status && <EventStatus status={event.status} />}
                </Box>

                {
                  <Box mb={2}>
                    <EventStartDate dateTime={event.startDateTime} />
                  </Box>
                }
                {
                  <Box mb={2}>
                    <EventStartTime dateTime={event.startDateTime} />
                  </Box>
                }
                {
                  <Box mb={2}>
                    <EventLocation name={event.locationName} />
                  </Box>
                }

                {/* Registered attendees */}
                <Box textAlign="left">
                  <Box sx={classes.cardContentItem}>
                    <RiGroupLine style={{marginRight: "12px",
      color: "#A8A8A8",}} />
                    {event.registeredAttendeesCount}
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      );
    });
  };

  return (
    <Grid container spacing={3} sx={classes.wrapper}>
      {showEventsList(events)}
    </Grid>
  );
};

export default EventsList;
